module.exports = {
      id: "rss-usage",
      viewBox: "0 0 13 12",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#rss",
      toString: function () {
        return this.url;
      }
    }